/**
 * /terceirizacao/* — router-shell do modulo Terceirizacao (Fase 10).
 *
 * Sub-rotas:
 *   /terceirizacao/oses (default) -> Lista de OSEs
 *   /terceirizacao/oses/:id -> Detalhe da OSE
 *   /terceirizacao/oses/criar -> Criar OSE
 *   /terceirizacao/parceiros -> CRUD de Parceiros
 *   /terceirizacao/pontualidade -> Relatorio de pontualidade
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import OsesLista from "./Oses/Lista";
import OseDetalhe from "./Oses/Detalhe";
import OseCriar from "./Oses/Criar";
import ParceirosLista from "./Parceiros/Lista";
import PontualidadeRelatorio from "./Pontualidade";
import Remessas from "./Remessas";

export default function TerceirizacaoShell() {
  return (
    <Routes>
      <Route index element={<Navigate to="oses" replace />} />
      <Route path="oses" element={<OsesLista />} />
      <Route path="oses/criar" element={<OseCriar />} />
      <Route path="oses/:id" element={<OseDetalhe />} />
      <Route path="parceiros" element={<ParceirosLista />} />
      <Route path="pontualidade" element={<PontualidadeRelatorio />} />
      <Route path="remessas" element={<Remessas />} />
      <Route path="*" element={<Navigate to="oses" replace />} />
    </Routes>
  );
}
